import gsap from 'gsap'
import Lenis from 'lenis'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export let lenis, scrollToStart

export const initLenis = () => {

  lenis = new Lenis({
		duration: 0.9,
		anchors: {
			offset: -118,
			duration: 1.8
		}
  })

	lenis.on('scroll', ScrollTrigger.update())

	gsap.ticker.add((time) => {
		lenis.raf(time * 1000)
	})

	gsap.ticker.lagSmoothing(0)

	function raf(time) {
		lenis.raf(time)
		requestAnimationFrame(raf)

		if (lenis.scroll > 50) {
      document.documentElement.dataset.scrolled = true
    } else {
      document.documentElement.dataset.scrolled = false
    }

		if (lenis.direction == 1 && lenis.scroll > 0) {
      document.documentElement.dataset.direction = 'forward'
    } else {
      document.documentElement.dataset.direction = 'backward'
    }
	}

	requestAnimationFrame(raf)

}

scrollToStart = () => {
  lenis.scrollTo(0, { immediate: true })
}

export default () => {}
